/** `timeApprove` translations, for every locale -- Time logging's Simple approval view. */
export const timeApprove = {
  mn: {
    timeApprove: {
      region: 'Шийдвэр хүлээж буй бүртгэлүүд',
      view: 'Харагдац',
      view_simple: 'Энгийн',
      view_detail: 'Дэлгэрэнгүй',
      kindCount: '{{kind}}: шийдвэр хүлээж буй {{count}}',
      loadFailed: 'Шийдвэр хүлээж буй бүртгэлийг ачаалж чадсангүй',
      empty: 'Шийдвэр хүлээж буй бүртгэл алга',
      colPick: 'Сонгох',
      colHours: 'Цаг',
      colLines: 'Мөрүүд',
      selectLog: '{{name}}, {{date}}, {{kind}} сонгох',
      allKinds: 'Бүгд',
      colDate: 'Огноо',
      selectPerson: '{{name}}-ын бүх бүртгэлийг сонгох',
      personSummary: 'Бүртгэл: {{count}}, {{hours}} ц',
      previousPayrollCount: 'Өмнөх цалингийн үе: {{count}}',
      openDay: 'Энэ өдрийг Дэлгэрэнгүй харагдацад нээх',
      moreLines: '+{{count}}',
      selectedHours: 'Сонгосон: {{count}}, {{hours}} ц',
      colPlanHours: 'Төлөвлөгөө',
      colFromTo: 'Эхэлсэн–дууссан',
      colComment: 'Тайлбар',
      colDetails: 'Дэлгэрэнгүй',
      showDetails: '{{name}}, {{date}}, {{kind}}-ийн дэлгэрэнгүйг харах',
      detailLines: 'Бүртгэсэн мөрүүд',
      clock: '{{from}}-аас {{to}} хүртэл',
      detailFailed: 'Энэ бүртгэлийн дэлгэрэнгүйг ачаалж чадсангүй.',
      unknownPerson: 'Нэр тодорхойгүй ажилтан',
      colPayroll: 'Цалингийн үе',
      payrollPrevious: 'Өмнөх',
      payrollCurrent: 'Одоогийн',
      hours: '{{hours}} ц',
      noLines: 'Мөргүй',
      noSelection: 'Эхлээд бүртгэл сонгоно уу',
      approve: 'Батлах ({{count}})',
      reject: 'Татгалзах',
      sendReject: 'Татгалзах ({{count}})',
      reason: 'Татгалзсан шалтгаан',
      reasonRequired: 'Татгалзсан шалтгааныг бичнэ үү',
      done: 'Шийдвэрлэсэн: {{count}}',
      partial: 'Шийдвэрлэсэн: {{decided}}, татгалзагдсан: {{refused}}',
      refused: 'Шийдвэрлэж чадсангүй: {{reason}}',
      refusedNoReason: 'Шийдвэрлэж чадсангүй, сервер шалтгаан заасангүй',
      filterPerson: 'Ажилтан',
      filterEveryone: 'Бүх ажилтан',
      filterProject: 'Төсөл',
      filterAllProjects: 'Бүх төсөл',
      filterFrom: 'Эхлэх огноо',
      filterTo: 'Дуусах огноо',
      filterDatesInverted: 'Дуусах огноо эхлэх огнооноос өмнө байна',
      filterPreviousOnly: 'Зөвхөн өмнөх цалингийн үе',
      filterClear: 'Шүүлтүүрийг цэвэрлэх',
      filterHelpLabel: 'Шүүлтүүр',
      filterHelp: 'Батлах, татгалзах үйлдэл зөвхөн харагдаж буй мөрүүдэд хамаарна. Шүүлтүүрт нуугдсан сонголт хадгалагдах боловч илгээгдэхгүй.',
      emptyFiltered: 'Шүүлтүүрт тохирох бүртгэл алга',
    },
  },
  en: {
    timeApprove: {
      region: 'Logs awaiting a decision',
      view: 'View',
      view_simple: 'Simple',
      view_detail: 'Detail',
      kindCount: '{{kind}}: {{count}} awaiting a decision',
      loadFailed: 'Could not load the logs awaiting a decision',
      empty: 'No logs awaiting a decision',
      colPick: 'Select',
      colHours: 'Hours',
      colLines: 'Lines',
      selectLog: 'Select {{name}}, {{date}}, {{kind}}',
      allKinds: 'All',
      colDate: 'Date',
      selectPerson: 'Select every log of {{name}}',
      personSummary: 'Logs: {{count}}, {{hours}} h',
      previousPayrollCount: 'Previous payroll: {{count}}',
      openDay: 'Open this day in Detail',
      moreLines: '+{{count}}',
      selectedHours: 'Selected: {{count}}, {{hours}} h',
      colPlanHours: 'Plan',
      colFromTo: 'From–to',
      colComment: 'Comment',
      colDetails: 'Details',
      showDetails: 'Show details of {{name}}, {{date}}, {{kind}}',
      detailLines: 'Logged lines',
      clock: 'From {{from}} to {{to}}',
      detailFailed: 'Could not load this log’s details.',
      unknownPerson: 'Unnamed person',
      colPayroll: 'Payroll',
      payrollPrevious: 'Previous',
      payrollCurrent: 'Current',
      hours: '{{hours}} h',
      noLines: 'No lines',
      noSelection: 'Select a log first',
      approve: 'Approve ({{count}})',
      reject: 'Reject',
      sendReject: 'Reject ({{count}})',
      reason: 'Reason for rejecting',
      reasonRequired: 'Write the reason for rejecting',
      done: 'Decided: {{count}}',
      partial: 'Decided: {{decided}}, refused: {{refused}}',
      refused: 'Not decided: {{reason}}',
      refusedNoReason: 'Not decided; the server gave no reason',
      filterPerson: 'Person',
      filterEveryone: 'Everyone',
      filterProject: 'Project',
      filterAllProjects: 'All projects',
      filterFrom: 'From',
      filterTo: 'To',
      filterDatesInverted: 'The end date is before the start date',
      filterPreviousOnly: 'Previous payroll only',
      filterClear: 'Clear filters',
      filterHelpLabel: 'Filters',
      filterHelp: 'Approve and reject act only on the rows showing. A row a filter hides stays selected but is not sent.',
      emptyFiltered: 'No logs match these filters',
    },
  },
  ru: {
    timeApprove: {
      region: 'Записи, ждущие решения',
      view: 'Вид',
      view_simple: 'Простой',
      view_detail: 'Подробный',
      kindCount: '{{kind}}: ждут решения {{count}}',
      loadFailed: 'Не удалось загрузить записи, ждущие решения',
      empty: 'Нет записей, ждущих решения',
      colPick: 'Выбор',
      colHours: 'Часы',
      colLines: 'Строки',
      selectLog: 'Выбрать: {{name}}, {{date}}, {{kind}}',
      allKinds: 'Все',
      colDate: 'Дата',
      selectPerson: 'Выбрать все записи: {{name}}',
      personSummary: 'Записей: {{count}}, {{hours}} ч',
      previousPayrollCount: 'Прошлый расчёт: {{count}}',
      openDay: 'Открыть этот день в подробном виде',
      moreLines: '+{{count}}',
      selectedHours: 'Выбрано: {{count}}, {{hours}} ч',
      colPlanHours: 'План',
      colFromTo: 'С–по',
      colComment: 'Комментарий',
      colDetails: 'Подробности',
      showDetails: 'Показать подробности: {{name}}, {{date}}, {{kind}}',
      detailLines: 'Записанные строки',
      clock: 'С {{from}} до {{to}}',
      detailFailed: 'Не удалось загрузить подробности записи.',
      unknownPerson: 'Сотрудник без имени',
      colPayroll: 'Расчёт',
      payrollPrevious: 'Прошлый',
      payrollCurrent: 'Текущий',
      hours: '{{hours}} ч',
      noLines: 'Без строк',
      noSelection: 'Сначала выберите запись',
      approve: 'Утвердить ({{count}})',
      reject: 'Отклонить',
      sendReject: 'Отклонить ({{count}})',
      reason: 'Причина отклонения',
      reasonRequired: 'Укажите причину отклонения',
      done: 'Решено: {{count}}',
      partial: 'Решено: {{decided}}, отказано: {{refused}}',
      refused: 'Не решено: {{reason}}',
      refusedNoReason: 'Не решено; сервер не указал причину',
      filterPerson: 'Сотрудник',
      filterEveryone: 'Все сотрудники',
      filterProject: 'Проект',
      filterAllProjects: 'Все проекты',
      filterFrom: 'С',
      filterTo: 'По',
      filterDatesInverted: 'Дата окончания раньше даты начала',
      filterPreviousOnly: 'Только прошлый расчётный период',
      filterClear: 'Сбросить фильтры',
      filterHelpLabel: 'Фильтры',
      filterHelp: 'Утверждение и отклонение действуют только на показанные строки. Скрытая фильтром строка остаётся выбранной, но не отправляется.',
      emptyFiltered: 'Нет записей под эти фильтры',
    },
  },
}
